// import React, { useEffect, useState, useMemo } from "react";
// import { DataTable } from "primereact/datatable";
// import { Column } from "primereact/column";
// import { Button } from "primereact/button";
// import { InputNumber } from "primereact/inputnumber";
// import { Dropdown } from "primereact/dropdown";
// import useAxiosPrivate from "../hooks/useAxiosPrivate";
// import { Card } from "primereact/card";
// const metodosPago = [
//   { label: "Efectivo", value: "efectivo" },
//   { label: "Transferencia", value: "transferencia" },
//   { label: "Tarjeta", value: "tarjeta" },
// ];

// const Pagos = () => {
//   const [matricula, setMatricula] = useState("");
//   const [alumnos, setAlumnos] = useState([]);
//   const [alumno, setAlumno] = useState(null);
//   const [cargos, setCargos] = useState([]);
//   const [selected, setSelected] = useState([]);
//   const [metodo, setMetodo] = useState("efectivo");
//   const [loading, setLoading] = useState(false);

//   useEffect(() => {
//     const loadAlumnos = async () => {
//       try {
//         const res = await axiosPrivate.get("CEUM/alumnos/listado");
//         setAlumnos(res.data);
//       } catch (e) {
//         console.error(e);
//       }
//     };
//     loadAlumnos();
//   }, []);

//   const axiosPrivate = useAxiosPrivate();
//   const buscar = async (matricula) => {
//     if (!matricula) return;
//     setLoading(true);
//     try {
//       const res = await axiosPrivate.get(`CEUM/cargos/${matricula}`);
//       const data = res.data.map((r) => ({ ...r, pagar: 0 }));
//       setCargos(data);
//       setSelected([]);
//     } catch (e) {
//       console.error(e);
//     } finally {
//       setLoading(false);
//     }
//   };
//   const onChangeMonto = (rowData, value) => {
//     const updated = cargos.map((r) =>
//       r.id === rowData.id ? { ...r, pagar: Number(value) || 0 } : r,
//     );
//     setCargos(updated);
//   };
//   const total = useMemo(() => {
//     return selected.reduce((acc, r) => acc + Number(r.pagar || 0), 0);
//   }, [selected]);

//   const onSelectionChange = (e) => {
//     const selectedRows = e.value.map((r) => ({
//       ...r,
//       pagar: r.pagar && r.pagar > 0 ? r.pagar : r.saldo,
//     }));
//     const updated = cargos.map((r) => {
//       const found = selectedRows.find((s) => s.id === r.id);
//       return found ? { ...r, pagar: found.pagar } : r;
//     });
//     setCargos(updated);
//     setSelected(selectedRows);
//   };
//   const registrarPago = async () => {
//     if (selected.length === 0) {
//       alert("Selecciona al menos un cargo");
//       return;
//     }
//     try {
//       await axiosPrivate.post("CEUM/pagos", {
//         matricula,
//         metodo_pago: metodo,
//         items: selected.map((r) => ({
//           id_cargo: r.id,
//           monto: r.pagar || r.saldo,
//         })),
//       });
//       alert("Pago registrado correctamente");
//       buscar();
//     } catch (error) {
//       console.error(error);
//       alert("Error al registrar pago");
//     }
//   };
//   const money = (v) => `$ ${Number(v || 0).toFixed(2)}`;
//   useEffect(() => {
//     if (alumno?.Matricula) {
//       buscar(alumno.Matricula);
//     }
//   }, [alumno]);
//   return (
//     <Card className="card" title="Registro de pagos">
//       <div className="flex gap-2 mb-3">
//         <Dropdown
//           value={alumno}
//           options={alumnos}
//           onChange={(e) => {
//             setAlumno(e.value);
//             if (!e.value) {
//               setCargos([]);
//             }
//           }}
//           optionLabel="nombre_completo"
//           placeholder="Selecciona alumno"
//           filter
//           showClear
//         />
//       </div>
//       {alumno && (
//         <div className="mb-3">
//           <strong>{alumno.nombre}</strong> ({alumno.matricula})
//         </div>
//       )}
//       <div className="mb-3" style={{ maxWidth: "250px" }}>
//         <label>Método de pago</label>
//         <Dropdown
//           value={metodo}
//           options={metodosPago}
//           onChange={(e) => setMetodo(e.value)}
//         />
//       </div>
//       <DataTable
//         value={cargos}
//         selection={selected}
//         onSelectionChange={onSelectionChange}
//         dataKey="id"
//         paginator
//         rows={10}
//         className="p-datatable-sm"
//       >
//         <Column selectionMode="multiple" style={{ width: "3rem" }} />
//         <Column field="concepto" header="Concepto" />
//         <Column field="periodo" header="Periodo" />
//         <Column field="fecha_vencimiento" header="Vencimiento" />
//         <Column header="Saldo" body={(row) => money(row.saldo)} />
//         <Column
//           header="Pagar"
//           body={(row) => (
//             <InputNumber
//               value={row.pagar}
//               onValueChange={(e) => onChangeMonto(row, e.value)}
//               mode="currency"
//               currency="MXN"
//               min={0}
//               max={row.saldo}
//             />
//           )}
//         />
//         <Column field="estatus" header="Estatus" />
//       </DataTable>
//       <div className="flex justify-content-end mt-3">
//         <h3>Total: {money(total)}</h3>
//       </div>
//       <div className="flex justify-content-end mt-3 gap-2">
//         <Button
//           label="Cancelar"
//           className="p-button-text"
//           onClick={() => setSelected([])}
//         />
//         <Button
//           label="Registrar Pago"
//           icon="pi pi-check"
//           onClick={registrarPago}
//         />
//       </div>
//     </Card>
//   );
// };
// export default Pagos;

import { TabView, TabPanel } from "primereact/tabview";
import { Card } from "primereact/card";

import PagosManual from "./PagosManual";
import PagosMasivos from "./PagosMasivos";

const Pagos = () => {
  return (
    <Card title="Gestión de Pagos">
      <TabView>

        <TabPanel header="Pago Manual">
          <PagosManual />
        </TabPanel>

        <TabPanel header="Pagos Masivos (Banco)">
          <PagosMasivos />
        </TabPanel>

      </TabView>
    </Card>
  );
};

export default Pagos;